<template>
    <div class="goTabPanelBody">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        name: "go-tab-panel-body"
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/layoutVue/go-tab-panel-body.vue